import { axiosInstance, parseResult } from "./CommonApi";

//회원가입
export const join = async (requestBody) => {
  const response = await axiosInstance.post(
    `/accounts/user/join/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//이메일 인증
export const verifyEmail = async (uidb64, token) => {
  const response = await axiosInstance.get(
    `/accounts/user/verify-email/${uidb64}/${token}/`
  );
  return parseResult(response);
};

//회원정보 조회
export const getUser = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(`/accounts/user/${id}/`, {
    params,
  });
  return parseResult(response);
};

//회원정보 수정
export const updateUser = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/accounts/user/${id}/update/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//아이디 중복 확인
export const checkDuplicateId = async (userId) => {
  const params = { userId: userId };
  const response = await axiosInstance.get(`/accounts/user/check-username/`, {
    params,
  });
  return parseResult(response);
};

//비밀번호 찾기
export const findPassword = async (userId, phoneNumber, email) => {
  const params = { userId: userId, phoneNumber: phoneNumber, email: email };
  const response = await axiosInstance.post(
    `/accounts/user/find-password/`,
    {},
    { params }
  );
  return parseResult(response);
};

//비밀번호 재설정
export const resetPassword = async (uidb64, token, password) => {
  const params = { uidb64: uidb64, token: token, password: password };
  const response = await axiosInstance.post(
    `/accounts/user/reset-password/`,
    {},
    { params }
  );
  return parseResult(response);
};

//아이디 찾기
export const findUserId = async (userName, phoneNumber, email) => {
  const params = { userName: userName, phoneNumber: phoneNumber, email: email };
  const response = await axiosInstance.post(
    `/accounts/user/find-username/`,
    {},
    { params }
  );
  return parseResult(response);
};

//회원탈퇴
export const deleteAccount = async (userId, phoneNumber, email) => {
  const params = { userId: userId, phoneNumber: phoneNumber, email: email };
  const response = await axiosInstance.post(
    `/accounts/user/delete-account/`,
    {},
    { params }
  );
  return parseResult(response);
};

//Obtain Token
export const login = async (requestBody) => {
  const response = await axiosInstance.post(
    `/accounts/auth/pair/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//Refresh Token
export const refreshToken = async (requestBody) => {
  const response = await axiosInstance.post(
    `/accounts/auth/refresh/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//Verify Token
export const verifyToken = async (requestBody) => {
  const response = await axiosInstance.post(
    `/accounts/auth/verify/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//Logout
export const logout = async (requestBody) => {
  const response = await axiosInstance.post(
    `/accounts/auth/logout/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

